import { render, staticRenderFns } from "./RenewConsentSuccess.vue?vue&type=template&id=7660e972&scoped=true&lang=html&"
import script from "./RenewConsentSuccess.vue?vue&type=script&lang=js&"
export * from "./RenewConsentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RenewConsentSuccess.vue?vue&type=style&index=0&id=7660e972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7660e972",
  null
  
)

export default component.exports